var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9854 20.7656H6.625C5.52043 20.7656 4.625 19.8702 4.625 18.7656V10.7656H8.55463C9.22334 10.7656 9.8478 10.4314 10.2187 9.87503L12.7344 6.10152C13.2908 5.26693 14.2275 4.76562 15.2306 4.76562H15.4445C16.0625 4.76562 16.5325 5.32049 16.4309 5.93002L15.625 10.7656H19.1854C20.4475 10.7656 21.3941 11.9203 21.1466 13.1579L19.9466 19.1579C19.7596 20.0927 18.9388 20.7656 17.9854 20.7656Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 10.7656V20.7656",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.bee6f11eadd8565d8ed7bdddc9eac2a8.svg";
export { ForwardRef as ReactComponent };